import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Paper, 
  Snackbar,
  Alert
} from '@mui/material';
import { checkUserRegistration } from './api';

const UserLookup = ({ onUserFound }) => {
  const [lookupType, setLookupType] = useState('email');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLookupTypeChange = (type) => {
    setLookupType(type);
    setEmail('');
    setPhone('');
  };

  const handleLookup = async (e) => {
    e.preventDefault();
    
    if (lookupType === 'email' && !email) {
      setError('Email is required');
      return;
    }

    if (lookupType === 'phone' && !phone) {
      setError('Phone number is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const isRegistered = await checkUserRegistration(
        lookupType === 'email' ? email : undefined,
        lookupType === 'phone' ? phone : undefined
      );
      
      onUserFound(
        isRegistered,
        lookupType === 'email' ? email : undefined,
        lookupType === 'phone' ? phone : undefined
      );
      
    } catch (err) {
      console.error('Lookup error:', err);
      setError('Error checking user status. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Enter Your Information
      </Typography>
      
      <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        <Button
          variant={lookupType === 'email' ? 'contained' : 'outlined'}
          onClick={() => handleLookupTypeChange('email')}
          sx={{ flex: 1 }}
        >
          Use Email
        </Button>
        <Button
          variant={lookupType === 'phone' ? 'contained' : 'outlined'}
          onClick={() => handleLookupTypeChange('phone')}
          sx={{ flex: 1 }}
        >
          Use Phone
        </Button>
      </Box>
      
      
      <Box component="form" onSubmit={handleLookup} noValidate>
        {lookupType === 'email' ? (
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
        ) : (
          <TextField
            margin="normal"
            required
            fullWidth
            id="phone"
            label="Phone Number"
            name="phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+1234567890"
            autoFocus
          />
        )}
        
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? 'Checking...' : 'Continue'}
        </Button>
      </Box>
      
      <Snackbar 
        open={error !== null} 
        autoHideDuration={6000} 
        onClose={() => setError(null)}
      >
        <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default UserLookup;
